var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('new-page-gen',{attrs:{"options":_vm.options,"on-form-initialized":_vm.onFormInitialized}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }